import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    // 主容器
    container: {
      // paddingLeft: '16px',
      position: 'relative',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
});